@if (breadcrumbs) {
    <div class="breadcrumbs__container">
        @if (breadcrumbs && breadcrumbs.length > 0) {
            @for (
                breadcrumb of breadcrumbs;
                track breadcrumb.label;
                let last = $last;
                let index = $index
            ) {
                @if (!last) {
                    <span
                        class="breadcrumbs__container__link"
                        (mousedown)="breadcrumb?.click ? breadcrumb?.click() : {}"
                        (keydown.enter)="breadcrumb?.click ? breadcrumb?.click() : {}"
                        nw-link
                        [tabindex]="index"
                        [innerHTML]="breadcrumb.label | sanitizeHtml"
                    >
                    </span>
                    <span class="breadcrumbs__container__divider">&#47;</span>
                } @else {
                    <span
                        class="breadcrumbs__container__link breadcrumbs__container__current"
                        (mousedown)="breadcrumb?.click ? breadcrumb?.click() : {}"
                        (keydown.enter)="breadcrumb?.click ? breadcrumb?.click() : {}"
                        [tabindex]="index"
                        [innerHTML]="breadcrumb.label | sanitizeHtml"
                    >
                    </span>
                }
            }
        }
    </div>
}
